/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PayrollViewerControllerGetCatalogs200ResponseDataEmployeesInner { 
    enrollment?: string;
    name?: string;
    sourceName?: string;
    socialSecurityNumber?: string;
    jobPosition?: string;
    department?: string;
    businessUnitId?: string;
    /**
     * Unidad de negocio del expediente
     */
    businessUnitName?: string;
    costCenter?: string;
    companyId?: string;
    companyCode?: string;
    companyName?: string;
    photoUrl?: string;
    totvsBranchCode?: string;
}

